module.exports = __webpack_public_path__ + "static/media/emojis2_09.33937bf3.svg";